var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof header !== "undefined") return resolve();
	__webpack_require__.l("https://voyager-uat.allmysons.com/header/latest/remoteEntry.js?v=1789543568979", (event) => {
		if(typeof header !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "header");
}).then(() => (header));